import { Component, EventEmitter, Input, OnInit, Output, QueryList, ViewChildren } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { ListColumn } from 'src/app/models/list-column.model';

@Component({
  selector: 'app-education-profile',
  templateUrl: './education-profile.component.html',
  styleUrls: ['./education-profile.component.scss']
})
export class EducationProfileComponent implements OnInit{
  @ViewChildren(MatAutocompleteTrigger) autoCompletes!: QueryList<MatAutocompleteTrigger>;

  educationDetailsColumns: ListColumn[] = [
    { name: 'Degree', property: 'degree', visible: true, isModelProperty: true ,isText: true},
    { name: 'From Year', property: 'yearFrom', visible: true, isModelProperty: true ,isText: true},
    { name: 'To Year', property: 'yearTo', visible: true, isModelProperty: true ,isText: true},
    { name: 'Institute Location', property: 'location', visible: true, isModelProperty: true ,isText: true},
    { name: 'Institute Name', property: 'instituteName', visible: true, isModelProperty: true ,isText: true},
    { name: 'Field of Study', property: 'fieldOfStudy', visible: true, isModelProperty: true ,isText: true},
  ] as ListColumn[];

  @Input() educationDetailsForm!:FormGroup;
  @Input() endCustomerData:any;
  showEditForm:boolean=false;
     copyEducationForm:any;
  data:any=[];
  degreeIcon:string="assets/images/degree-icon.svg";
  

  @Output() onUpdate:EventEmitter<any>=new EventEmitter();

  yearDropdown:any=[];
  futureYearDropdown:any=[];
  
  filteredYearDropdown: { [key: number]: number[] } = {};
  filteredFutureYearDropdown: { [key: number]: number[] } = {};
  
  constructor(private fb :FormBuilder ){
    window.addEventListener('scroll', this.scrollEvent, true);
  }
  ngOnInit(): void {
    
    this.data=JSON.parse(JSON.stringify( this.educationDetailsForm.get('educationInfos')?.value));
       // Ensure form array controls have validators
       this.applyValidators();
       this.getYearDropdown();
       this.getFutureYearDropdown();

       this.educationInfos.controls.forEach((_, index) => {
       this.filteredYearDropdown[index] = [...this.yearDropdown];
       this.filteredFutureYearDropdown[index] = [...this.futureYearDropdown]; 
    });
  }


filterYears(index: number, type: string) {
  const inputValue = this.educationInfos.at(index).get(type)?.value || '';
  if (type === 'yearFrom') {
    this.filteredYearDropdown[index] = this.yearDropdown.filter((year: number) =>
      year.toString().includes(inputValue.toString())
    );
  } else if (type === 'yearTo') {
    this.filteredFutureYearDropdown[index] = this.futureYearDropdown.filter((year: number) =>
      year.toString().includes(inputValue.toString())
    );
  }
  this.educationInfos.at(index).get(type)?.updateValueAndValidity();
}


onYearSelected(event: any, index: number, type: string) {
  this.educationInfos.at(index).get(type)?.setValue(event.option.value);
}

scrollEvent = (event: any): void => {
  const target = event.target as HTMLElement
  const isScrollingInsidePanel = this.autoCompletes.some(autoComplete => {
    if(autoComplete.panelOpen){
      const panel = autoComplete.autocomplete.panel;
      return panel && panel.nativeElement.contains(target);
    }
    return false;
  })
  if(!isScrollingInsidePanel){
    this.closeAllPanels();
  }
}

closeAllPanels() {
  this.autoCompletes.forEach(autoComplete => {
    if (autoComplete.panelOpen) {
      autoComplete.closePanel();
    }
  });
}

  applyValidators(): void {
    const degreeValidators = [ 
        Validators.maxLength(50),
        Validators.pattern(/^[a-zA-Z\s]*$/)
    ];

    const instituteValidators = [
        Validators.maxLength(150),
        Validators.pattern(/^[a-zA-Z0-9\s]*$/)
    ];

    const locationValidators = [
        Validators.maxLength(50),
        Validators.pattern(/^[A-Za-z0-9\s.,\-/#&]+$/)
    ];

    const fieldOfStudyValidators = [
        Validators.maxLength(150),
        Validators.pattern(/^[a-zA-Z\s]*$/)
    ];

    if (this.educationInfos && this.educationInfos.controls.length) {
        this.educationInfos.controls.forEach((control) => {
            const educationControl = control as FormGroup;
            educationControl.get('degree')?.setValidators(degreeValidators);
            educationControl.get('instituteName')?.setValidators(instituteValidators);
            educationControl.get('location')?.setValidators(locationValidators);
            educationControl.get('fieldOfStudy')?.setValidators(fieldOfStudyValidators);

            educationControl.get('degree')?.updateValueAndValidity();
            educationControl.get('instituteName')?.updateValueAndValidity();
            educationControl.get('location')?.updateValueAndValidity();
            educationControl.get('fieldOfStudy')?.updateValueAndValidity();
        });
    }
  }

  getYearDropdown(){
    for(let year=new Date().getFullYear();year>=1947;year--){
      this.yearDropdown.push(year);
    }
  }

  getFutureYearDropdown(){
    for(let year=new Date().getFullYear()+5;year>=1947;year--){
      this.futureYearDropdown.push(year);
    }
  }

  get educationInfos() {
    return this.educationDetailsForm?.controls["educationInfos"] as FormArray;
  }

  addFirstEducation() {
    this.educationInfos.push(this.fb.group({
      id: new FormControl(null),
      active: new FormControl(null),
      createdBy: new FormControl(null),
      createdOn: new FormControl(null),
      modifiedBy: new FormControl(null),
      modifiedOn: new FormControl(null),
      "degree": new FormControl(null),
      "yearFrom": new FormControl(null),
      "yearTo": new FormControl(null),
      "location": new FormControl(null),
      "instituteName":new FormControl(null),
      "fieldOfStudy": new FormControl(null),
    }));
    this.applyValidators();
  this.showEditForm = true;
}
addEducation() {
  this.copyEducationForm = JSON.parse(JSON.stringify(this.educationDetailsForm.value));
  
  const lastEducation = this.educationInfos.at(this.educationInfos.length - 1);
  if (lastEducation && Object.values(lastEducation.value).some(value => value !== null && value !== '')) {
    this.educationInfos.push(this.fb.group({
      id: new FormControl(null),
      active: new FormControl(null),
      createdBy: new FormControl(null),
      createdOn: new FormControl(null),
      modifiedBy: new FormControl(null),
      modifiedOn: new FormControl(null),
      "degree": new FormControl(null),
      "yearFrom": new FormControl(null),
      "yearTo": new FormControl(null),
      "location": new FormControl(null),
      "instituteName":new FormControl(null),
      "fieldOfStudy": new FormControl(null),
    }));
  }
  this.applyValidators();
  this.showEditForm = true;
}

editEducation(){
  this.copyEducationForm=JSON.parse(JSON.stringify(this.educationDetailsForm.value)); 
  this.showEditForm=true;
}

update(){
  this.educationInfos.markAllAsTouched();
  this.applyValidators();
  if(this.educationInfos.invalid){
    return;
  }
this.onUpdate.emit(30);
}

refresh(){
  this.showEditForm=false;
  this.data=JSON.parse(JSON.stringify( this.educationDetailsForm.get('educationInfos')?.value));
  
}

cancel(){
    
  (this.educationDetailsForm.get('educationInfos')as FormArray).clear();
   if(this.copyEducationForm?.educationInfos && this.copyEducationForm.educationInfos.length>0){
        for(let i=0;i<this.copyEducationForm.educationInfos.length;i++){
          if(!(this.copyEducationForm.educationInfos[i].degree==null || this.copyEducationForm.educationInfos[i].degree==''
            ||this.copyEducationForm.educationInfos[i].yearFrom==null || this.copyEducationForm.educationInfos[i].yearFrom==''
            ||this.copyEducationForm.educationInfos[i].yearTo==null || this.copyEducationForm.educationInfos[i].yearTo==''
            ||this.copyEducationForm.educationInfos[i].location==null || this.copyEducationForm.educationInfos[i].location==''
            ||this.copyEducationForm.educationInfos[i].instituteName==null || this.copyEducationForm.educationInfos[i].instituteName==''
            ||this.copyEducationForm.educationInfos[i].fieldOfStudy==null || this.copyEducationForm.educationInfos[i].fieldOfStudy==''
            )){
            (this.educationDetailsForm.get('educationInfos')as FormArray).push( this.fb.group({
              id:new FormControl(null),
              active:new FormControl(null),
              createdBy:new FormControl(null),
              createdOn:new FormControl(null),
              modifiedBy:new FormControl(null),
              modifiedOn:new FormControl(null),
              "degree"  :new FormControl(null),
              "yearFrom": new FormControl(null),
              "yearTo": new FormControl(null),
              "location": new FormControl(null),
              "instituteName":new FormControl(null),
              "fieldOfStudy": new FormControl(null),
            }));
          }
        }
        (this.educationDetailsForm.get('educationInfos')as FormArray).patchValue(this.copyEducationForm.educationInfos);
      }
     
  this.showEditForm=false;
  this.data=JSON.parse(JSON.stringify( this.educationDetailsForm.get('educationInfos')?.value));
 


}
handleKeyDown(event: KeyboardEvent) {
  if (event.key === "Enter") {
    event.preventDefault(); 
  }
}



deleteEducation(i:number){
this.educationInfos.removeAt(i);
}
}
